import React from 'react';
import './Badge.css';

function Badge({
  children,
  variant = 'neutral',
  size = 'md',
  className = '',
  ...rest
}) {
  const classes = [
    'ui-badge',
    `ui-badge--${variant}`,
    `ui-badge--${size}`,
    className,
  ].filter(Boolean).join(' ');
  return (
    <span className={classes} {...rest}>
      {children}
    </span>
  );
}

export default Badge;
